class Error {
  code = 0
  message = ''
  source = ''
}

/**
 * 返回状态对象
 */
export class ResponseStatus {
  /**
   * 返回 http code
   * 400 500 401 等
   */
  httpCode = 200
  /**
   * 业务异常
   */
  code = 200
  /**
   * 相关信息
   */
  message: string | undefined
  /**
   * 错误类型
   */
  type = ''
  /**
   * 错误源
   */
  source = ''
  errors: Array<Error> = new Array<Error>()

  constructor(code: number, message?: string) {
    this.code = code
    this.message = message
  }

  hasError() {
    return !!this.errors.length
  }

  getMessage(): string {
    const message: Array<string> = new Array<string>()
    this.errors.forEach((error: Error) => {
      message.push(error.message)
    })
    return message.join(',')
  }

  /**
   * 判断执行结果是否成功，包括网络状态 和 业务状态
   */
  isSuccess() {
    return this.httpCode === 200 && this.code === 200
  }

  /**
   * 判断网络请求是否成功
   */
  isNetSuccess() {
    return this.httpCode === 200
  }
}

/**
 * ajax请求返回对象
 */
export default class Response<T> {
  status: ResponseStatus = new ResponseStatus(200, '')
  data: T
}
